import { User, AppState } from '@/types';

export const createUserActions = (state: AppState, dispatch: any) => {
  const login = (email: string, password: string, name: string): boolean => {
    // Legacy function - authentication now handled by useAuth hook
    return false;
  };

  const logout = () => {
    // Legacy function - authentication now handled by useAuth hook
  };

  const updateWeeklyGoal = (goal: number) => {
    dispatch({ type: 'UPDATE_WEEKLY_GOAL', payload: { goal } });
  };

  const updateUserProfile = (updates: Partial<User>) => {
    dispatch({ type: 'UPDATE_USER_PROFILE', payload: { updates } });
  };

  const redeemPrize = (pointCost: number, prizeName: string) => {
    dispatch({ type: 'REDEEM_PRIZE', payload: { pointCost, prizeName } });
  };

  const spendActivityCredits = (amount: number) => {
    dispatch({ type: 'SPEND_ACTIVITY_CREDITS', payload: { amount } });
  };

  const markWeeklySummaryShown = () => {
    dispatch({ type: 'MARK_WEEKLY_SUMMARY_SHOWN' });
  };

  return {
    login,
    logout,
    updateWeeklyGoal,
    updateUserProfile,
    redeemPrize,
    spendActivityCredits,
    markWeeklySummaryShown
  };
};